import React from 'react';
import { BackdropLoader, SimpleModal } from '@livable/saas-react-components';
import { Button } from '@mui/material';
import { track, events } from 'src/configs/amplitude';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
export const LogoutModal = observer(_ref => {
  let isOpen = _ref.isOpen,
    handleOpen = _ref.handleOpen,
    handleClose = _ref.handleClose;
  const store = useStore();
  const navigate = useNavigate();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const logout = async () => {
    await store.account.logoutAccountAsync.run();
    track(events.loggedOut());
    store.auth.reset();
    store.payment.resetPaymentMethods();
    store.account.setIsInvite(false);
    navigate('/login');
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose,
    title: t('general.log_out_from_pm_portal'),
    noPadding: true,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: logout,
      'custom-attribute': '338-LogoutModal'
    }, t('general.yes_log_out'))
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.account.logoutAccountAsync.inProgress
  }));
});